import React, { useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Input, Button, Avatar } from "react-native-elements";
import Icon from "react-native-vector-icons/FontAwesome";
import { db, auth } from "../firebase";
import { AntDesign, FontAwesome, Ionicons } from "@expo/vector-icons";
import { StatusBar } from "react-native";
import { ScrollView } from "react-native";
import { TextInput } from "react-native";
import * as firebase from "firebase";
import { Keyboard } from "react-native";

const ChatScreen = ({ navigation, route }) => {
  React.useLayoutEffect(() => {
    navigation.setOptions({
      title: "Chat",
      headerBackTitleVisible: false,
      headerTitleAlign: "left",
      headerTitle: () => (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Avatar
            rounded
            source={{
              uri: "https://i.pravatar.cc/150",
            }}
          />
          <Text
            style={{
              marginLeft: 10,
              fontWeight: 50,
              color: "white",
            }}
          >
            {route.params.chat_name}
          </Text>
        </View>
      ),
      headerRight: () => (
        <View
          style={{
            width: 80,
            flexDirection: "row",
            justifyContent: "space-between",
            marginRight: 20,
          }}
        >
          <TouchableOpacity>
            <FontAwesome name="video-camera" size={24} color="white" />
          </TouchableOpacity>
          <TouchableOpacity>
            <Ionicons name="call" size={24} color="white" />
          </TouchableOpacity>
        </View>
      ),
    });
  }, [navigation]);

  const [message, set_message] = React.useState("");
  const [messages, set_messages] = React.useState([]);

  const scrollViewRef = React.useRef();

  const send_message = () => {
    Keyboard.dismiss();

    db.collection("chats").doc(route.params.id).collection("messages").add({
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      displayName: auth.currentUser.displayName,
      photoURL: auth.currentUser.photoURL,
      email: auth.currentUser.email,
      message,
    });

    set_message("");
  };

  React.useLayoutEffect(() => {
    const unsubsribe = db
      .collection("chats")
      .doc(route.params.id)
      .collection("messages")
      .orderBy("timestamp", "asc")
      .onSnapshot((snapshot) => {
        set_messages(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }))
        );
      });

    return unsubsribe;
  }, [route]);

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <StatusBar style="light" />
      <View style={styles.container}>
        <ScrollView
          style={{ height: 200 }}
          ref={scrollViewRef}
          onContentSizeChange={() =>
            scrollViewRef.current.scrollToEnd({ animated: true })
          }
        >
          {messages.map((message) => {
            var email = message.data.email;
            var photoURL = message.data.photoURL;
            var id = message.data.id;
            var message = message.data.message;

            if (email === auth.currentUser.email) {
              return (
                <View key={id} style={styles.sender_container}>
                  <View key={id} style={styles.sender}>
                    <Text style={styles.message}>{message}</Text>
                  </View>
                  <View>
                    <Avatar
                      source={{
                        uri: photoURL,
                      }}
                      size={30}
                      rounded
                    />
                  </View>
                </View>
              );
            } else {
              return (
                <View key={id} style={styles.receiver_container}>
                  <View>
                    <Avatar
                      source={{
                        uri: photoURL,
                      }}
                      size={30}
                      rounded
                    />
                  </View>
                  <View
                    key={id}
                    style={[styles.receiver, styles.receiver_message]}
                  >
                    <Text
                      style={[styles.message, styles.receiver_message_text]}
                    >
                      {message}
                    </Text>
                  </View>
                </View>
              );
            }
          })}
        </ScrollView>
        <View style={styles.footer}>
          <TextInput
            placeholder="Type your message"
            value={message}
            onChangeText={(new_message) => set_message(new_message)}
            style={styles.message_field}
            onSubmitEditing={() => (message ? send_message() : "")}
          />
          <TouchableOpacity onPress={() => send_message()} disabled={!message}>
            <Ionicons name="send" color="#2B68E6" size={24} />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default ChatScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  footer: {
    width: "100%",
    padding: 20,
    flexDirection: "row",
    alignItems: "center",
  },
  message_field: {
    width: "100%",
    padding: 10,
    borderRadius: 20,
    borderColor: "transparent",
    backgroundColor: "#ECECEC",
    marginRight: 15,
  },
  sender: {
    backgroundColor: "#FAFAFA",
    paddingHorizontal: 10,
    margin: 10,
    borderRadius: 10,
    // maxWidth: "40%",
  },
  sender_container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "fit-content",
    alignSelf: "flex-end",
    justifyContent: "flex-end",
    marginHorizontal: 10,
  },
  receiver: {
    backgroundColor: "#FAFAFA",
    paddingHorizontal: 10,
    margin: 10,
    borderRadius: 10,
    // maxWidth: "40%",
  },
  receiver_container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "fit-content",
    alignSelf: "flex-start",
    justifyContent: "flex-start",
    marginHorizontal: 10,
  },
  message: {
    padding: 10,
  },
  receiver_message: {
    backgroundColor: "#2080dc",
  },
  receiver_message_text: {
    color: "white",
  },
});
